import { useState } from "react";
import useReveal from "../hooks/useReveal";
import Navbar from "../components/Navbar/Navbar";
import Newsletter from "../components/Newsletter/Newsletter";
import Footer from "../components/Footer/Footer";
import "./Services.css";

const TESTIMONIALS = [
  { name: "Ashutosh Singh", role: "CEO", company: "Tech Startup Inc", rating: 4.5, quote: "iGamesTech delivered an exceptional game that exceeded our expectations. Their expertise, creativity, and professionalism made the entire development process smooth and enjoyable. Highly recommended!" },
  { name: "Rohit Yadav", role: "CTO", company: "Game Studios Ltd", rating: 5.0, quote: "Outstanding service and exceptional quality. Highly recommended for game development." },
  { name: "Harshit", role: "Founder", company: "Mobile Apps Co", rating: 4.5, quote: "Professional team with great expertise in mobile and web development." },
  { name: "Rachit", role: "Director", company: "Digital Solutions", rating: 5.0, quote: "They delivered beyond our expectations. Will definitely work with them again." },
  { name: "Ankit", role: "Product Manager", company: "Innovation Labs", rating: 4.5, quote: "Exceptional work quality and timely delivery. Great communication throughout." },
  { name: "Lisa", role: "VP Engineering", company: "Tech Giants Inc", rating: 5.0, quote: "Best development partner we've worked with. Highly skilled and professional team." },
  { name: "Anshika", role: "Co-Founder", company: "StartupHub", rating: 4.5, quote: "Amazing results! They understood our vision and brought it to life perfectly." },
  { name: "Ashish Singh", role: "CMO", company: "Digital Media Co", rating: 5.0, quote: "Outstanding creativity and technical expertise. Will definitely work together again." },
];

export default function Services() {
  useReveal();
  const [activeSlide, setActiveSlide] = useState(0);
  const [selectedCard, setSelectedCard] = useState(0);

  const itemsPerSlide = 3;
  const totalSlides = Math.ceil(TESTIMONIALS.length / itemsPerSlide);

  const nextSlide = () => {
    setActiveSlide((prev) => (prev + 1) % totalSlides);
    setSelectedCard(0);
  };

  const prevSlide = () => {
    setActiveSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
    setSelectedCard(0);
  };

  const getCurrentTestimonials = () => {
    const start = activeSlide * itemsPerSlide;
    return TESTIMONIALS.slice(start, start + itemsPerSlide);
  };

  return (
    <>
      <Navbar />

      {/* ══ HERO ══ */}
      <section className="srv-hero">
        <div className="srv-hero-inner reveal">
          <h1>Our Services</h1>
          <p>We deliver end-to-end game and app development services designed to scale your ideas into successful digital products.</p>
        </div>
      </section>

      {/* ══ STATISTICS ══ */}
      <section className="srv-stats">
        <div className="srv-stats-container reveal">
          <div className="srv-stat-item">
            <div className="srv-stat-icon">
              <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 00-3-3.87"/>
                <path d="M16 3.13a4 4 0 010 7.75"/>
              </svg>
            </div>
            <div className="srv-stat-text">
              <h3>100+</h3>
              <p>Clients</p>
            </div>
          </div>
          <div className="srv-stat-divider"/>
          <div className="srv-stat-item">
            <div className="srv-stat-icon">
              <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
                <circle cx="12" cy="10" r="3"/>
              </svg>
            </div>
            <div className="srv-stat-text">
              <h3>10+</h3>
              <p>Countries</p>
            </div>
          </div>
          <div className="srv-stat-divider"/>
          <div className="srv-stat-item">
            <div className="srv-stat-icon">
              <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
                <polyline points="9 22 9 12 15 12 15 22"/>
              </svg>
            </div>
            <div className="srv-stat-text">
              <h3>50+</h3>
              <p>Projects</p>
            </div>
          </div>
        </div>
      </section>

      {/* ══ WHAT WE DO ══ */}
      <section className="srv-what">
        <div className="srv-2col">
          <div className="srv-video-box reveal">
            <img src="/k.jpg" alt="What We Do" className="srv-video-img" loading="lazy" />
          </div>
          <div className="srv-text reveal">
            <h2>What We Do</h2>
            <p>We help businesses and startups build high-quality games and applications using modern technologies, creative design, and proven development practices.</p>
            <ul className="srv-list">
              <li><span>✓</span> Custom Game Development</li>
              <li><span>✓</span> Mobile & Web App Development</li>
              <li><span>✓</span> UI/UX Design & Prototyping</li>
              <li><span>✓</span> Cross-Platform Solutions</li>
            </ul>
          </div>
        </div>
      </section>

      {/* ══ CUSTOM GAME DEVELOPMENT ══ */}
      <section className="srv-detail srv-alt">
        <div className="srv-2col">
          <div className="srv-text reveal">
            <h2>Custom Game Development</h2>
            <p>We design and develop high-quality games tailored to your vision—focused on performance, engagement, and scalability across platforms.</p>
            <p>From concept and design to development and launch, our team ensures smooth gameplay and memorable user experiences.</p>
            <button className="srv-btn">Read more</button>
          </div>
          <div className="srv-image-box reveal">
            <img src="/service3-3.png" alt="Custom Game Development" className="srv-detail-img" loading="lazy" />
          </div>
        </div>
      </section>

      {/* ══ MOBILE & WEB APP ══ */}
      <section className="srv-detail">
        <div className="srv-2col">
          <div className="srv-image-box reveal">
            <img src="/RG4.jpg" alt="Mobile & Web App Development" className="srv-detail-img" loading="lazy" />
          </div>
          <div className="srv-text reveal">
            <h2>Mobile & Web App Development</h2>
            <p>We build fast, secure, and scalable mobile and web applications tailored to your business goals and user needs.</p>
            <p>Our solutions prioritize user experience, modern design, performance, and long-term scalability across platforms.</p>
            <button className="srv-btn">Read more</button>
          </div>
        </div>
      </section>

      {/* ══ UI/UX DESIGN ══ */}
      <section className="srv-detail srv-alt">
        <div className="srv-2col">
          <div className="srv-text reveal">
            <h2>UI/UX Design & Prototyping</h2>
            <p>We create intuitive, user-focused designs that enhance usability and deliver visually engaging digital experiences.</p>
            <p>From wireframes to interactive prototypes, we ensure every design aligns with user behavior and business goals.</p>
            <button className="srv-btn">Read more</button>
          </div>
          <div className="srv-image-box reveal">
            <img src="/RG6.jpg" alt="UI/UX Design & Prototyping" className="srv-detail-img" loading="lazy" />
          </div>
        </div>
      </section>

      {/* ══ TESTIMONIALS — Interactive Carousel ══ */}
      <section className="srv-testimonials">
        <div className="srv-testimonials-inner">
          <div className="srv-testimonials-header reveal">
            <h2>Trusted by Thousands of<br/>Happy Customer</h2>
            <p>Businesses worldwide trust iGamesTech to deliver high-quality games and digital solutions.</p>
          </div>
          
          <div className="srv-testimonials-slider">
            <div className="srv-testimonials-track" style={{ transform: `translateX(-${activeSlide * 100}%)` }}>
              {Array.from({ length: totalSlides }).map((_, slideIndex) => (
                <div className="srv-testimonials-slide" key={slideIndex}>
                  {TESTIMONIALS.slice(slideIndex * itemsPerSlide, (slideIndex + 1) * itemsPerSlide).map((t, cardIndex) => {
                    const globalIndex = slideIndex * itemsPerSlide + cardIndex;
                    const isActive = slideIndex === activeSlide && cardIndex === selectedCard;
                    return (
                      <div 
                        className={`srv-testimonial-card ${isActive ? 'active' : ''}`} 
                        key={globalIndex}
                        onClick={() => setSelectedCard(cardIndex)}
                      >
                        <div className="srv-testimonial-header">
                          <div className="srv-testimonial-avatar"/>
                          <div className="srv-testimonial-info">
                            <h4>{t.name}</h4>
                            <p>{t.company}</p>
                          </div>
                          <div className="srv-testimonial-rating">
                            {t.rating} <span>★</span>
                          </div>
                        </div>
                        <p className="srv-testimonial-quote">{t.quote}</p>
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          </div>

          <div className="srv-testimonials-controls">
            <div className="srv-dots">
              {Array.from({ length: totalSlides }).map((_, i) => (
                <span 
                  key={i} 
                  className={i === activeSlide ? 'active' : ''}
                  onClick={() => { setActiveSlide(i); setSelectedCard(0); }}
                />
              ))}
            </div>
            <div className="srv-arrows">
              <button className="srv-arrow-left" onClick={prevSlide}>
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="15 18 9 12 15 6"/>
                </svg>
              </button>
              <button className="srv-arrow-right" onClick={nextSlide}>
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="9 18 15 12 9 6"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ══ WHY CHOOSE ══ */}
      <section className="srv-why">
        <div className="srv-why-inner reveal">
          <h2>Why Choose iGamesTech</h2>
          <p>With years of experience in game and app development, our expert team delivers scalable, secure, and visually engaging solutions trusted by clients worldwide.</p>
        </div>
      </section>

      <Newsletter />
      <Footer />
    </>
  );
}
